/** 组织机构 / 分会子站 — 前后台共用 */

export const BRANCH_SITE_SECTIONS = [
  { id: 'home', title: '首页', icon: 'home', kind: 'news-home' },
  { id: 'overview', title: '分会概况', icon: 'info', kind: 'page', pageCode: 'branch_overview' },
  { id: 'council', title: '委员会', icon: 'groups', kind: 'personnel', personnelGroup: '委员会' },
  { id: 'work', title: '工作动态', icon: 'newspaper', kind: 'news', newsCategory: '工作动态' },
  { id: 'announcements', title: '通知公告', icon: 'campaign', kind: 'announcements' },
  { id: 'history', title: '历史沿革', icon: 'history', kind: 'timeline' },
  { id: 'gallery', title: '历史相册', icon: 'photo_library', kind: 'gallery' },
  { id: 'science', title: '科学传播', icon: 'science', kind: 'science' },
  { id: 'awards', title: '获奖成果', icon: 'emoji_events', kind: 'awards' },
  { id: 'downloads', title: '下载中心', icon: 'download', kind: 'downloads' }
]

export const BRANCH_SECTION_IDS = BRANCH_SITE_SECTIONS.map(s => s.id)

export const BRANCH_DOWNLOAD_CATEGORIES = [
  '会议简讯',
  '会议论文摘要集',
  '入会申请表',
  '其他'
]

export const BRANCH_SCIENCE_CATEGORIES = [
  '工作动态',
  '期刊服务',
  '科普基地',
  '科普文章',
  '科普视频',
  '化石保护'
]

export const BRANCH_OVERVIEW_PAGE_CODE = 'branch_overview'
export const SOCIETY_OVERVIEW_PAGE_CODE = 'society_overview'
export const BRANCH_ORGANIZATION_PAGE_CODE = 'branch_organization'
/** @deprecated 前台组织机构页已不再展示；后台 CMS 仍可维护 */
export const STRUCTURE_MANAGEMENT_PAGE_CODE = 'structure_management'

export const STRUCTURE_PANELS = [
  { id: 'management', title: '管理机构', pageCode: STRUCTURE_MANAGEMENT_PAGE_CODE }
]

export const STRUCTURE_PAGE_CODES = STRUCTURE_PANELS.map(p => p.pageCode)

export const STRUCTURE_PAGE_LABELS = Object.fromEntries(
  STRUCTURE_PANELS.map(p => [p.pageCode, p.title])
)

export function isMainAssociation(item) {
  return !!(
    item &&
    (item.associationType === 'MAIN' ||
      item.associationId === 1 ||
      item.branchCode === 'zgswxh')
  )
}

export function sortSocietiesMainFirst(list) {
  const arr = Array.isArray(list) ? list.slice() : []
  return arr.sort((a, b) => {
    const am = isMainAssociation(a) ? 0 : 1
    const bm = isMainAssociation(b) ? 0 : 1
    return am - bm
  })
}

/** 前台展示名：去掉「（总学会）」/「(总学会)」后缀 */
export function displayAssociationName(itemOrName) {
  const name =
    typeof itemOrName === 'string'
      ? itemOrName
      : (itemOrName && itemOrName.associationName) || ''
  const cleaned = String(name).replace(/\s*[（(]总学会[）)]\s*/g, '').trim()
  return cleaned || name
}

/**
 * 分会子站路径。使用 associationId（或分会业务 id）拼路径，不依赖 BRANCH_IDS 常量。
 * @param {string|number} associationId
 * @param {string} [section='home']
 */
export function branchSitePath(associationId, section = 'home') {
  const id = associationId == null ? '' : String(associationId)
  const sec = section || 'home'
  return `/structure/branch/${id}/${sec}`
}

/** 分会内容详情始终保留分会与栏目上下文，避免回落到总站公共详情路由。 */
export function branchContentPath(associationId, section, entryId) {
  const base = branchSitePath(associationId, section)
  const id = entryId == null ? '' : String(entryId)
  return id ? `${base}/content/${id}` : base
}

export function resolveBranchSection(section) {
  const found = BRANCH_SITE_SECTIONS.find(s => s.id === section)
  return found || BRANCH_SITE_SECTIONS[0]
}

/**
 * 总学会与专业分会共用子站骨架，但概况/理事会（委员会）文案与分组键不同。
 * @param {boolean} isMain 是否总学会（MAIN）
 */
export function branchSiteSectionsFor(isMain) {
  return BRANCH_SITE_SECTIONS.map(section => {
    if (section.id === 'overview') {
      if (!isMain) return { ...section }
      return {
        ...section,
        title: '学会概况',
        pageCode: SOCIETY_OVERVIEW_PAGE_CODE
      }
    }
    if (section.id === 'council') {
      if (!isMain) return { ...section }
      return {
        ...section,
        title: '理事会',
        personnelGroup: '理事会'
      }
    }
    return { ...section }
  })
}

export function resolveBranchSectionFor(section, isMain) {
  const sections = branchSiteSectionsFor(!!isMain)
  const found = sections.find(s => s.id === section)
  return found || sections[0]
}

export function isStructurePageCode(code) {
  return String(code || '').startsWith('structure_')
}
